import FacebookBlue from "./FacebookBlue.vue";
import FacebookWhite from "./FacebookWhite.vue";
import TwitterBlue from "./TwitterBlue.vue";
import TwitterWhite from "./TwitterWhite.vue";
import Google from "./Google.vue";
import Steam from "./Steam.vue";

export default {
  IconFacebookBlue: FacebookBlue,
  IconFacebookWhite: FacebookWhite,
  IconTwitterBlue: TwitterBlue,
  IconTwitterWhite: TwitterWhite,
  IconGoogle: Google,
  IconSteam: Steam
};
